import React from 'react';
import PropTypes from 'prop-types';

export default class ScrollToTop extends React.Component {
  static propTypes = {
    location: PropTypes.object,
    children: PropTypes.node
  };

  static defaultProps = {
    location: {},
    children: null
  };

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/components/ScrollToTop/ScrollToTop.js